import { topicCategories } from '@/mocks/home';

interface CategorySectionProps {
  onSelectCategory: (category: string) => void;
}

export default function CategorySection({ onSelectCategory }: CategorySectionProps) {
  return (
    <section id="categories" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl mb-10">
          <p className="text-xs tracking-[0.3em] text-primary-600 font-medium mb-2">CATEGORIES</p>
          <h2 className="font-heading font-black text-2xl md:text-4xl text-foreground-950">
            按方向找到你想吃的瓜
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            六个常驻分类覆盖了站内大多数话题。点进任意一个分类，下方的最新瓜料会立刻按它筛选，省去一页页翻找的时间。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {topicCategories.map((category) => (
            <button
              key={category.id}
              type="button"
              onClick={() => onSelectCategory(category.name)}
              className="group text-left bg-background-50 border border-background-200/70 hover:border-primary-300 rounded-lg p-6 transition-colors cursor-pointer"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 text-xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={category.icon} aria-hidden="true"></i>
                </span>
                <span className="font-heading font-black text-sm text-foreground-300 group-hover:text-primary-400 transition-colors">
                  {String(category.count).padStart(3, '0')}
                </span>
              </div>
              <h3 className="mt-5 font-heading font-bold text-lg text-foreground-950">
                {category.name}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {category.description}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                查看瓜料
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}